<template>
  <div>
    <deal-form
      v-if="showDealForm"
      :deal-id="dealId"
      :is-read-only="isReadOnly"
      :modal-visible="showDealForm"
      :isDialog="false"
      @close="toggleDealForm"
      :dealTypeId="1"
    />

    <schedule-delivery-form
      v-if="scheduleModalVisible"
      :operation-id="operationId"
      :is-read-only="isReadOnly"
      :schedule-modal-visible="scheduleModalVisible"
      @close="toggleScheduleDeliveryModal"
    />

    <send-undelivered-mail-form
      v-model="undeliveredMailFormOpen"
      :selected-operations="selectedOperations"
      :form-params="formParams"
      @success="onSuccessUndeliveredMailForm($event)"
    />

    <drawdown-form
      v-if="drawdownModalVisible"
      :value="drawdownModalVisible"
      :selected-operations="selectedOperations"
      :as-of-date="lastParams.asOfDate"
      @success="toggleDrawdownModal"
      @input="drawdownModalVisible = $event"
      @mailSent="refreshScreen"
    />
    <full-drawdown-form
      v-if="fullDrawdownModalVisible"
      :value="fullDrawdownModalVisible"
      :selected-operations="selectedOperations"
      :as-of-date="lastParams.asOfDate"
      @success="toggleFullDrawdownModal"
      @input="fullDrawdownModalVisible = $event"
      @mailSent="refreshScreen"
    />

    <send-undelivered-confirm-form
      :value="sendUndeliveredConfirmVisible"
      @success="sendUndeliveredConfirmSuccess($event)"
      @input="sendUndeliveredConfirmVisible = $event"
    />

    <page-toolbar>
      <undelivery-toolbar
        @change="onChange"
        @export="onExport"
        v-slot="slotProps"
        :marketId="marketId"
        :refresh-key="refreshKey"
      >
        <kendo-button
          type="button"
          @click="onExport(slotProps.toolbar.getSelectedValues())"
          icon="excel"
          title="Export to Excel"
        />
        <span v-if="!sendingView">
          <vonap-toolbar-label label="Check All">
            <v-switch
              v-model="checkAll"
              @change="onCheckAllChanged"
              :style="'display:inline-block;margin:-6px 0;width:61px;top: 4px;position:relative'"
            >
            </v-switch>
          </vonap-toolbar-label>
        </span>
        <span v-if="!sendingView">
          <kendo-button title="Full Drawdown" @click="openDrawdownModal" class="k-button-icon">
            <i class="fas fa-chart-line"></i>
          </kendo-button>
        </span>
        <kendo-button
          type="button"
          v-show="isMaster"
          :title="sendingView ? 'Mail All Undelivered Balance Report' : 'Create sending list'"
          class="k-button-icon"
          @click="sendAllMail"
        >
          <i class="fa fa-paper-plane"></i>
        </kendo-button>
        <kendo-button
          type="button"
          v-show="isMaster"
          :class="{'k-force-state-active': sendingView}"
          @click="toggleSendingView"
          icon="list-bulleted"
          title="Sending View"
          style="position:absolute; left: 950px;"
        />
      </undelivery-toolbar>
    </page-toolbar>
    <sending-list-grid
      :date="lastParams && lastParams.asOfDate"
      :analyst-email="lastParams && lastParams.analystEmail"
      :responsible-email="lastParams && lastParams.responsibleEmail"
      :reconciled-client="lastParams && lastParams.reconciledClient"
      :forward-option-id="lastParams && lastParams.optionValue"
      v-if="lastParams != null && sendingView"
      @changed="refreshScreen"
    />
    <div class="text-xs-center" v-show="!sendingView">
      <v-progress-circular
        color="primary"
        :size="50"
        :width="7"
        :indeterminate="true"
        v-if="rendering"
      ></v-progress-circular>
      <v-progress-linear
        color="primary"
        height="15"
        :indeterminate="true"
        v-if="rendering"
      ></v-progress-linear>
    </div>
    <div ref="container" class="exposureGrid" v-show="!rendering && !sendingView"></div>
  </div>
</template>

<script>
import axios from 'axios'
const $ = kendo.jQuery
import PageToolbar from '@/components/PageToolbar'
import VonapToolbarLabel from '@/components/VonapToolbarLabel'
import UndeliveryToolbar from '@/components/Report/UndeliveryToolbar'
import undeliveredBalanceGrid from '@/dashboard-components/undelivered-balance-grid'
import SendUndeliveredMailForm from '@/components/SendUndeliveredMailForm'
import DealForm from '@/views/List/Deal/DealForm'
import ScheduleDeliveryForm from '../../views/List/Deal/ScheduleDeliveryForm'
import DrawdownForm from '../../views/List/Deal/DrawdownForm'
import FullDrawdownForm from '../../views/List/Deal/FullDrawdownForm'
import {getDataItem} from '../../helpers/kendo-helpers'
import notification from '@/helpers/notification'
import params from '@/helpers/params'
import {mapGetters} from 'vuex'
import security from '@/mixins/security'
import SendingListGrid from '@/components/SendingListGrid'
import SendUndeliveredConfirmForm from '@/components/SendUndeliveredConfirmForm'

export default {
  name: 'UndeliveredBalance',
  mixins: [security],
  data() {
    return {
      chartDialog: false,
      rendering: false,
      lastParams: null,
      clientId: 0,
      showDealForm: false,
      scheduleModalVisible: false,
      drawdownModalVisible: false,
      fullDrawdownModalVisible: false,
      multiDrawdownModalVisible: true,
      checkAll: false,
      selectedOperations: [],
      undeliveredMailFormOpen: false,
      sendingView: false,
      sendUndeliveredConfirmVisible: false,
      testMode: false,
      testEmail: '',
      formParams: {
        title: 'Mail Undelivered Balance Report.',
        clientId: 0,
        ccyPairId: 0,
        optionForwardId: 0,
      },
      refreshKey: 0,
    }
  },
  mounted() {
    document.body.addEventListener('click', this.linkClick, false)
    document.body.addEventListener('change', this.checkboxChange, false)
  },
  beforeDestroy() {
    document.body.removeEventListener('click', this.linkClick)
    document.body.removeEventListener('change', this.checkboxChange)
    kendo.destroy(this.$refs.container)
  },
  methods: {
    refreshScreen() {
      this.refreshKey = Math.ceil(Math.random() * 1000)
    },
    onChange(e) {
      this.checkAll = false
      const $container = kendo.jQuery(this.$refs.container)
      $container.empty()
      this.lastParams = e
      this.clientId = +this.selectedClientId

      this.rendering = true
      const vm = this
      undeliveredBalanceGrid
        .render($container, this.lastParams, 'report', vm.isMaster)
        .then(function() {
          vm.rendering = false
          vm.checkAll = false
        })
    },
    onExport(e) {
      const qs = params.fromObject({
        t: this.tokenString,
        url: location.origin,
        ...e,
      })
      location.href = `/api/report/ExposureReport/exportUndeliveredBalance?${qs}`
    },
    openUndeliveredMailForm(target) {
      this.getAllChecked()
      if (!this.sendUndeliveredConfirmVisible && this.selectedOperations.length == 0) {
        notification('Please select one before open send email.', 'error')
        return
      }
      const clientId = +target.dataset.clientid
      const ccyPairId = +target.dataset.ccypairid
      const optionForwardId = +target.dataset.optionforwardid
      this.formParams.sendingListId = +(
        kendo
          .jQuery(target)
          .closest('button')
          .get(0).dataset.sendinglistid || 0
      )
      this.formParams.clientId = clientId
      this.formParams.ccyPairId = ccyPairId
      this.formParams.optionForwardId = optionForwardId
      this.formParams.asOfDate = this.lastParams.asOfDate
      this.formParams.reconciledClient = this.lastParams.reconciledClient
      this.undeliveredMailFormOpen = true
    },
    onSuccessUndeliveredMailForm(e) {
      if (e.testMode) return

      const clientId = e.clientId
      const ccyPairId = e.ccyPairId
      const optionForwardId = e.optionForwardId
      const $buttonId = `#sendUndeliveredForm_${clientId}_${ccyPairId}_${optionForwardId}_button`
      $($buttonId).removeClass()
      $($buttonId).addClass(`undeliveredMail k-button-icon k-button ${e.status}`)
    },
    toggleDealForm() {
      this.showDealForm = !this.showDealForm
    },
    toggleScheduleDeliveryModal() {
      this.scheduleModalVisible = !this.scheduleModalVisible
    },
    openDrawdownModal() {
      this.getAllChecked()
      this.toggleFullDrawdownModal()
    },
    toggleDrawdownModal() {
      if (!this.drawdownModalVisible && this.selectedOperations.length == 0) {
        notification('Please select one before run Drawdown.', 'error')
        return
      }

      this.drawdownModalVisible = !this.drawdownModalVisible
    },
    toggleFullDrawdownModal() {
      if (!this.fullDrawdownModalVisible && this.selectedOperations.length == 0) {
        notification('Please select one before run Drawdown.', 'error')
        return
      }

      this.fullDrawdownModalVisible = !this.fullDrawdownModalVisible
    },
    toggleMultiDrawdownModal() {
      if (!this.multiDrawdownModalVisible && this.selectedOperations.length == 0) {
        notification('Please select one before run Drawdown.', 'error')
        return
      }
      this.multiDrawdownModalVisible = !this.multiDrawdownModalVisible
    },
    getCheckedOnGrid(clientId, ccyPairId, optionForwardId) {
      let vm = this
      const grid = $(`#clientGrid_${clientId}_${ccyPairId}_${optionForwardId}`).data('kendoGrid')
      const dataRows = grid.items()
      this.selectedOperations = []
      dataRows.each(function() {
        const rowItem = $('td input:checked', this)
        if (rowItem[0] && rowItem[0].checked) {
          const operationId = +rowItem[0].className.match(/checkboxDrawDown_(\d+)$/)[1]
          vm.selectedOperations.push(operationId)
        }
      })
    },
    getAllChecked() {
      let vm = this
      let allCheckbox = $('input:checked')
      this.selectedOperations = []
      allCheckbox.each(function(r, k) {
        if (k.className.startsWith('checkboxDrawDown_') && k.checked) {
          const operationId = +this.className.match(/checkboxDrawDown_(\d+)$/)[1]
          vm.selectedOperations.push(operationId)
        }
      })
    },
    onCheckAllChanged(e) {
      const isChecked = e
      $('input:checkbox.checkAll').each(function() {
        this.checked = !isChecked
        this.click()
      })

      if (!isChecked) {
        this.selectedOperations = []
      }
    },
    async linkClick({target}) {
      if (/dealLink/.test(target.className)) {
        const dataItem = getDataItem(target)
        this.dealId = dataItem.dealId
        this.toggleDealForm()
      } else if (/deliveryScheduleLink/.test(target.className)) {
        const dataItem = getDataItem(target)
        this.operationId = dataItem.operationId
        this.toggleScheduleDeliveryModal()
      } else if (/buttonDrawdown/.test(target.className)) {
        const clientId = +target.dataset.clientid
        const ccyPairId = +target.dataset.ccypairid
        const optionForwardId = +target.dataset.optionforwardid
        this.getCheckedOnGrid(clientId, ccyPairId, optionForwardId)
        this.toggleDrawdownModal()
      } else if (/buttonSaveComments/.test(target.className)) {
        const commentId = +target.dataset.id
        const clientId = +target.dataset.clientid
        const ccyPairId = +target.dataset.ccypairid
        const optionForwardId = +target.dataset.optionforwardid
        const textarea = $(`textarea#comments_${clientId}_${ccyPairId}_${optionForwardId}_textBox`)
        const mailButton = document.getElementById(
          `sendUndeliveredForm_${clientId}_${ccyPairId}_${optionForwardId}_button`,
        )
        mailButton.setAttribute('data-sendinglistid', commentId)

        const comments = textarea.val()
        let data = {
          sendingListId: commentId,
          sendComments: comments,
        }

        if (commentId == 0) {
          data = {
            clientId: clientId,
            asOfDate: this.lastParams.asOfDate,
            sendingListId: 0,
            sendComments: comments,
            manualSettings: {optionValue: optionForwardId, ccyPairId: ccyPairId},
          }
          const result = await axios.post(
            '/api/report/ExposureReport/AddUndeliveredBalanceSendingList',
            data,
          )

          if (result.status == 200) {
            const messageId = result.data
            notification('Sending list created successfully', 'success')
            document
              .getElementById(`key_${clientId}_${ccyPairId}_${optionForwardId}_button`)
              .setAttribute('data-id', messageId)
            document
              .getElementById(`key_${clientId}_${ccyPairId}_${optionForwardId}_icon`)
              .setAttribute('data-id', messageId)
            $(`#sendUndeliveredForm_${clientId}_${ccyPairId}_${optionForwardId}_button`).addClass(
              `OnHold`,
            )
            mailButton.setAttribute('data-sendinglistid', messageId)
            textarea.show()
          } else {
            notification('Some error', 'error')
          }
        } else {
          const result = await axios.post(
            '/api/report/ExposureReport/UpdateUndeliveredBalanceSendingList',
            data,
          )
          if (result.status == 200) {
            notification('Comment update successfully', 'success')
          } else {
            notification('Some error', 'error')
          }
        }
      } else if (/undeliveredMail/.test(target.className)) {
        this.openUndeliveredMailForm(target)
      }
    },
    checkboxChange(e) {
      if (/checkboxDrawDown_(\d+)$/.test(e.target.className)) {
        const operationId = +e.target.className.match(/checkboxDrawDown_(\d+)$/)[1]
        const checked = e.target.checked
        if (checked) {
          if (!this.selectedOperations.includes(operationId))
            this.selectedOperations.push(operationId)
        } else {
          let index = this.selectedOperations.indexOf(operationId)
          if (index !== -1) this.selectedOperations.splice(index, 1)
        }
      }
    },
    toggleSendingView() {
      this.sendingView = !this.sendingView
    },
    async sendReadyToSend() {
      await axios.post('/api/report/ExposureReport/SendReadyToSendEmails', {
        testMode: this.testMode,
        testEmail: this.testEmail,
        asOfDate: this.lastParams.asOfDate,
        responsibleEmail: this.lastParams.responsibleEmail,
        analystEmail: this.lastParams.analystEmail,
        reconciledClient: this.lastParams.reconciledClient,
      })
      notification('Sent successfully', 'success')
      this.toggleSendingView()
      window.setTimeout(() => this.toggleSendingView(), 10)
    },
    toggleSendUndeliveredConfirmVisible() {
      this.sendUndeliveredConfirmVisible = !this.sendUndeliveredConfirmVisible
    },
    async sendUndeliveredConfirmSuccess(e) {
      this.testMode = e.testMode
      this.testEmail = e.testEmail

      await this.sendReadyToSend()
      this.toggleSendUndeliveredConfirmVisible()
    },
    async sendAllMail() {
      if (this.sendingView) {
        return this.toggleSendUndeliveredConfirmVisible()
      }

      const items = kendo
        .jQuery('input.checkAll:checked')
        .get()
        .map(({dataset}) => ({
          clientId: +dataset.clientid,
          ccyPairId: +dataset.ccypairid,
          optionForwardId: +dataset.optionforwardid,
        }))
      const data = {
        testMode: this.testMode,
        testEmail: this.testEmail,
        asOfDate: this.lastParams.asOfDate,
        items,
      }
      const result = await axios.post('/api/report/ExposureReport/Verify', data)
      const hasData = result.data
      if (hasData) {
        if (
          !confirm(
            'For the selected date month we found some existing entries for some Clients & Currency Pairs, do you want to continue?',
          )
        )
          return
      }
      await axios.post('/api/report/ExposureReport/SaveSendingList', data)
      notification('Sending List items created successfully', 'success')
      this.sendingView = true
    },
  },
  computed: {
    ...mapGetters({tokenString: 'authentication/tokenString'}),
    ...mapGetters({marketId: 'app/marketId'}),
    ...mapGetters({selectedClientId: 'authentication/selectedClientId'}),

    isMaster() {
      return this.selectedClientId == 0
    },
  },
  components: {
    PageToolbar,
    VonapToolbarLabel,
    UndeliveryToolbar,
    SendUndeliveredMailForm,
    DealForm,
    ScheduleDeliveryForm,
    DrawdownForm,
    FullDrawdownForm,
    SendingListGrid,
    SendUndeliveredConfirmForm,
  },
}
</script>

<style>
.exposureGrid {
  font-size: 0.9em;
}
.k-force-state-active {
  border-color: rgba(0, 0, 0, 0.08) !important;
  color: #ffffff !important;
  background-color: #1e355e !important;
}
</style>
